
// Open minicart
$('body').on("click", ".header__icon--cart", function(event) {
  window.refresh_cart();
  $('body').addClass('active-mini-cart');
  event.preventDefault();
});

// Close minicart on <body> click
$('.c-navigation-overlay').click(function(e) {
  if($('body').hasClass('active-mini-cart')){
    $('body').removeClass('active-mini-cart');
  }
});

// Close mini cart
$('body').on("click", ".cart-mini-header-close .c-mini-cart__close",  function() {
  $('body').removeClass('active-mini-cart');
});

// Close mini cart
document.querySelector('.js-mini-cart-close-trigger').addEventListener('click', function(event) {
  event.preventDefault();
  $('body').removeClass('active-mini-cart')
});

// Dynamic Discount toast open
$(document).mouseup(function(e){
  let container = $(".c-mini-cart");
  if (!container.is(e.target) && container.has(e.target).length === 0 && container.css('transform') != 'none'){
    let toast = document.querySelector('toast-message');
    if (toast && $('.c-mini-cart__label').text().includes('Subscription')
    && ($('.c-mini-cart__product-name').text().includes('Revaree')
      || $('.c-mini-cart__product-name').text().includes('Clairvee')
      || $('.c-mini-cart__product-name').text().includes('Ristela')
      || $('.c-mini-cart__product-name').text().includes('Relizen')
      || $('.c-mini-cart__product-name').text().includes('Serenol'))) toast.open($('.c-mini-cart__product').length);
  }
});

// Dynamic Discount toast open when closing minicart
$("[js-mini-cart-close-trigger]").bind( "click", function() {
  let toast = document.querySelector('toast-message');
  if (toast && $('.c-mini-cart__label').text().includes('Subscription')
    && ($('.c-mini-cart__product-name').text().includes('Revaree')
      || $('.c-mini-cart__product-name').text().includes('Clairvee')
      || $('.c-mini-cart__product-name').text().includes('Ristela')
      || $('.c-mini-cart__product-name').text().includes('Relizen')
      || $('.c-mini-cart__product-name').text().includes('Serenol'))) toast.open($('.c-mini-cart__product').length);
});


// Decrease mini cart item quantity
$("body").on('click', ".button-wrapper button.reduction", function(e){
  e.preventDefault();
  let currentValue = $(this).closest('.c-mini-cart__input-wrapper-new').find('.c-mini-cart__input').val();
  currentValue--;
  if (currentValue<1){
    currentValue = 0;
  }
  $(this).closest('.c-mini-cart__input-wrapper-new').find('.c-mini-cart__input').val(currentValue).trigger('change');
  e.stopImmediatePropagation();
  return false;
});

// Increase mini cart item quantity
$("body").on('click', ".button-wrapper button.increment", function(e){
  e.preventDefault();
  let currentValue = parseInt($(this).closest('.c-mini-cart__input-wrapper-new').find('.c-mini-cart__input').val());
  currentValue++;
  $(this).closest('.c-mini-cart__input-wrapper-new').find('.c-mini-cart__input').val(currentValue).trigger('change');
  e.stopImmediatePropagation();
  return false;
});

// Remove minicart item
$('body').on('click','.cart-mini-item-removes', function(e){
  e.preventDefault();
  animateCartContents('out');
  let $this = $(this);
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {

      // Free Samples (Manual) -- 'data-attr-free_sample' will also include GWP Auto items
      if ($this.closest('.c-mini-cart__row').attr('data-attr-free_sample') == 'true'){
        let $sample = $(".mini-cart__free-samples__products__product[data-variant_id='"+$this.closest('.c-mini-cart__row').attr('data-variant-id')+"']");
        $sample
          .find('.mini-cart__free-samples__products__product__add-to-cart')
          .removeClass('in-cart')
          .html('Add');
        $(".mini-cart__free-samples__products__product")
          .removeClass('disabled')
          .find('.mini-cart__free-samples__products__product__add-to-cart')
          .prop( "disabled", false );

        // Remove minicart item and exit function: we don't need to update the ATC button label
        $this.closest('.c-mini-cart__row').find('.c-mini-cart__input').val('0').trigger('change');
        return;
      }

      // Cross Sell (Manual)
      if ($this.closest('.c-mini-cart__row').attr('data-attr-cross_sell_product')=='true'){
        let $sample = $(".mini-cart__cross-sell__products__product[data-variant_id='"+$this.closest('.c-mini-cart__row').attr('data-variant-id')+"']");
        $sample
          .find('.mini-cart__cross-sell__products__product__add-to-cart')
          .removeClass('in-cart')
          .html('Add');
      }

      // Update ATC Label
      const variantId = $this.closest('.c-mini-cart__product').attr('data-variant-id');

      // Enable product buy box ATC button (regular, bundle, or B2B product)
      let productBtns = []
      let partialBundleBtns = []

      //check if regular product
      let $productBtnRegular = $(".c-product-purchase__form .c-product-purchase__type[data-variant-id='"+variantId+"']").parent().find('button[type="submit"]');
      if($productBtnRegular.length) productBtns.push($productBtnRegular);

      //check if B2B product
      if(!!$this.closest('.c-mini-cart__product').attr('data-is-b2b')){
        let $productBtnB2B = $(".c-product-purchase__form__b2b[data-variant-id='"+variantId+"']").find('button[type="submit"]');
        if($productBtnB2B.length) productBtns.push($productBtnB2B)
      }

      //check if bundle
      const $productBeingRemoved = $this.closest('.c-mini-cart__product')

      // find monthly purchase options using [data-swap-ids]. These will only be present on bundle buy boxes
      $(".c-product-purchase__form .c-product-purchase__type--subscription[data-swap-ids]").each(function(){
        const $purchaseOption = $(this);

        // check if bundle swap ids includes the variant id being removed
        if($purchaseOption.attr('data-swap-ids').includes(`${variantId}`)){
          //the product being removed belongs to a bundle buy box on the DOM,
            // BUT need to check if the bundle has other items in cart

          // check any other products in cart and if they also belong to bundle increment a counter to keep track
          let count = 0;

          // Get total number of products in bundle
          const bundleIds = JSON.parse($purchaseOption.attr('data-swap-ids'));
          const productCountInBundle = Object.keys(bundleIds).length;

          $productBeingRemoved.closest('.c-mini-cart__product').siblings().each(function(){
            const siblingVariantId = $(this).attr('data-variant-id');
            if ($(this).attr('data-attr-free_sample') !== 'true') {
              // If item in cart is not a free sample or GWP and is part of bundle, increase bundle items-in-cart count
              if($purchaseOption.attr('data-swap-ids').includes(`${siblingVariantId}`)) count++;
            }
          });

          let $productBtnBundle = $purchaseOption.parent().find('button[type="submit"]');
          // If we have an ATC button and fewer bundle products in the cart than in the bundle:
          if ($productBtnBundle.length && count < productCountInBundle) {
            //if no other cart products belong to the bundle, then this bundle ATC button can be re-enabled
            if (count <= 0) {
              productBtns.push($productBtnBundle)
            //some amount of bundle products are still in the cart, adjust to partial ATC button
            } else if (count > 0) {
              partialBundleBtns.push($productBtnBundle);
            }
          }
        }
      });

      for (const $btn of productBtns) {
        $btn.prop('disabled', false);
        updatePurchaseStatusMessages($btn, "allowed");

        // PDP Add-ons
        if($btn.hasClass('has-addons')) {
          const productUrl = $btn.attr('data-product-url') || window.location.pathname;
          if (productUrl && productUrl.includes('products')) {
            $.ajax({
              type: 'GET',
              url: productUrl+'?view=addons',
              dataType: 'html',
              success: function(addonsHTML){
                setTimeout(() => {
                  $("#bundle-creator-container").hide();
                  $("#bundle-creator-container").html(addonsHTML);
                  $btn.parents('.c-product-purchase__form').find('input.c-product-purchase__radio:checked').trigger('click');
                  $("product-addons").show();
                  $("#bundle-creator-container").show();
                }, 1000);
              }
            });
          }
        }
      }

      for (const $btn of partialBundleBtns) {
        $btn.prop('disabled', false);
        updatePurchaseStatusMessages($btn, "partial");
      }

      // Update sticky ATC label
      if((productBtns && productBtns.length) || (partialBundleBtns && partialBundleBtns.length)) {
        const stickyAtcButton = document.querySelector('sticky-atc-button');
        if(stickyAtcButton) {
          if (productBtns.length) {
            updatePurchaseStatusMessages(stickyAtcButton, "allowed");
          }
          if (partialBundleBtns.length) {
            updatePurchaseStatusMessages(stickyAtcButton, "partial");
          }
        }
      }

      // Remove minicart item
      $this.closest('.c-mini-cart__row').find('.c-mini-cart__input').val('0').trigger('change');

    }
  });
  setTimeout(function() {
    window.DynamicDiscount.init();
  }, 250);
  return false;
});

// Minicart item quantity input change event
$(document).on('change', '.c-mini-cart__input', function(e) {
  e.preventDefault();
  animateCartContents('out');

  let $this = $(this).closest('.c-mini-cart__row');
  let variantId = $this.attr('data-variant-id');
  let key = $this.attr('data-key');

  let itemId = variantId;
  // If there are multiple items with the same variant id, use the item key instead
  const sameVariantId = document.querySelector('.cart-items-list-wrapper')?.querySelectorAll(`[data-variant-id="${variantId}"]`);
  if (sameVariantId.length > 1) {
    itemId = key;
  }

  let quantity = parseInt($(this).val());
  let formData = {
    "id": itemId,
    "quantity": quantity
  }

  // Limit single box item quantity if max provided
  const singleBoxMaxQty = parseInt($this.attr('data-single-box-max'));
  if (singleBoxMaxQty && quantity > singleBoxMaxQty) {
    quantity = singleBoxMaxQty;
    formData.quantity = quantity;
  }

  // Limit B2B products to quantity_rule max
  const b2bProductMaxQty = parseInt($this.attr('data-b2b-max-quantity'));
  if (b2bProductMaxQty && quantity > b2bProductMaxQty) {
    quantity = b2bProductMaxQty;
    formData.quantity = quantity;
  }

  // Auto GWP manually removed - set session storage
  if($this.is("[data-is-auto-gwp]")) {
    sessionStorage.setItem('auto-gwp-was-manually-removed', true)
  }
  // Eligible product that gets an Auto GWP was removed - delete session storage
  else if($this.is("[data-gets-auto-gwp]")) {
    sessionStorage.removeItem('auto-gwp-was-manually-removed')
  }

  // Update cart data
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(response => response.json()).then(data => {
    //refresh cart
    refresh_cart(data);
    //Disatch item removed or updated event
    if(quantity == 0){
      document.dispatchEvent(new CustomEvent("cart:item:removed", { detail: data }));
    }else if(quantity > 0){
      document.dispatchEvent(new CustomEvent("cart:item:updated"));
    }
  }).catch((error) => {
    console.error('Error:', error);
  });
});

// Update any Buy Box buttons after item(s) added to cart
document.addEventListener('cart:item:added', e => {
  // Wait for mini-cart to be open before updating ATC text
  if (document.body.classList.contains('active-mini-cart')) {
    toggleBuyBoxPurchaseAllowed();
  } else {
    document.addEventListener('minicart:open', e => {
      toggleBuyBoxPurchaseAllowed();
    }, { once: true });
  }
});

function updatePurchaseStatusMessages(element, currentStatus) {
  // Set active and inactive text for Add to Cart button,
  // e.g. c-product-purchase__status--allowed or c-product-purchase__status--denied (js-purchase-allowed, js-purchase-denied)
  $(element).find(`.c-product-purchase__status:not(.c-product-purchase__status--${currentStatus}`).removeClass("is-active");
  $(element).find(`.c-product-purchase__status--${currentStatus}`).addClass("is-active");
}

function toggleBuyBoxPurchaseAllowed() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {

      // cart is empty, so enable ATC buttons
      if(cart.items.length <= 0) {
        $(".c-product-purchase__form").find('button[type="submit"][js-product-add-to-cart]').each(function(){
          const $btn = $(this);
          $btn.prop('disabled', false);
          updatePurchaseStatusMessages($btn, "allowed");

          // enable PDP Add-ons
          if($btn.hasClass('has-addons')) {
            const productUrl = $btn.attr('data-product-url') || window.location.pathname;
            if (productUrl && productUrl.includes('products')) {
              $.ajax({
                type: 'GET',
                url: productUrl+'?view=addons',
                dataType: 'html',
                success: function(addonsHTML){
                  setTimeout(() => {
                    $("#bundle-creator-container").hide();
                    $("#bundle-creator-container").html(addonsHTML);
                    $btn.parents('.c-product-purchase__form').find('input.c-product-purchase__radio:checked').trigger('click');
                    $("product-addons").show();
                    $("#bundle-creator-container").show();
                  }, 1000);
                }
              });
            }
          }
        });

        return;
      }

      // cart is not empty, so find all ATC buttons that belong to item in cart
      let productBtns = []
      let partialBundleBtns = []
      for (const item of cart.items) {
        if (item.properties._is_free_sample || item.properties._is_auto_GWP) {
          // Skip free samples, don't update ATC label
          continue;
        }

        const variantId = item.variant_id

        // regular product
        let $productBtnRegular = $(".c-product-purchase__form .c-product-purchase__type[data-variant-id='"+variantId+"']").parent().find('button[type="submit"]');
        if($productBtnRegular.length) productBtns.push($productBtnRegular);

        //  B2B product
        let $productBtnB2B = $(".c-product-purchase__form__b2b[data-variant-id='"+variantId+"']").find('button[type="submit"]');
        if($productBtnB2B.length) productBtns.push($productBtnB2B)

        // bundle products
        // find monthly purchase options using [data-swap-ids]. These will only be present on bundle buy boxes
        $(".c-product-purchase__form .c-product-purchase__type--subscription[data-swap-ids]").each(function(){
          const $purchaseOption = $(this);
          // check if bundle swap ids includes the cart item variant id
          if($purchaseOption.attr('data-swap-ids').includes(`${variantId}`)){
            // cart item is part of bundle: get the IDs and count of the bundle products
            const bundleIds = JSON.parse($purchaseOption.attr('data-swap-ids'));
            const productCountInBundle = Object.keys(bundleIds).length;

            // get an array of all the non-sample cart items' IDs, as strings
            const cartProducts = cart.items.filter((item) => !item.properties._is_free_sample && !item.properties._is_auto_GWP);
            const cartIds = cartProducts.map((item) => `${item.id}`);
            // running list of bundle items in the cart
            const bundleIdsInCart = {};

            // For each bundle product:
            Object.entries(bundleIds).forEach(([oneMonth, threeMonth]) => {
              // If either the 1-month or 3-month variant is in the cart, add to running list
              if (cartIds.includes(`${oneMonth}`) || cartIds.includes(`${threeMonth}`)) {
                bundleIdsInCart[oneMonth] = threeMonth;
              }
            });

            // Get total of bundle items actually in the cart
            const bundleItemsInCartCount = Object.keys(bundleIdsInCart).length;
            // If there are any bundle items in the cart:
            if (bundleItemsInCartCount > 0) {
              // Get product ATC button
              let $productBtnBundle = $purchaseOption.parent().find('button[type="submit"]');
              if($productBtnBundle.length) {
                // All items from bundle are in the cart, disable Add to Cart (same as standard products)
                if (bundleItemsInCartCount == productCountInBundle) {
                  productBtns.push($productBtnBundle);
                // Some items from bundle are in the cart, change Add to Cart messaging for partial bundle
                } else {
                  partialBundleBtns.push($productBtnBundle);
                }
              }
            }
          }
        });

      }

      // Disable each ATC button
      for (const $btn of productBtns) {
        $btn.prop('disabled', true);
        updatePurchaseStatusMessages($btn, "denied");
      }

      // Keep partial bundle ATC enabled, update messaging
      for (const $btn of partialBundleBtns) {
        $btn.prop('disabled', false);
        updatePurchaseStatusMessages($btn, "partial");
      }

      // Disable sticky ATC button
      if((productBtns && productBtns.length) || (partialBundleBtns && partialBundleBtns.length)) {
        const stickyAtcButton = document.querySelector('sticky-atc-button');
        if(stickyAtcButton) {
          if (productBtns.length) {
            updatePurchaseStatusMessages(stickyAtcButton, "denied");
          }
          if (partialBundleBtns.length) {
            updatePurchaseStatusMessages(stickyAtcButton, "partial");
          }
        }
      }
    }
  });
}

// Refesh minicart
function refresh_cart(cart, callback = null){

  //Update items
  $.ajax({
    type: 'GET',
    url: '/cart?view=mini-ajax',
    success: function(cart){
      $(".hc-mini-table").html(cart);
      let items_in_cart = $(".hc-mini-table").find('input#items_in_cart').val();
      updateCounts(items_in_cart)
      // Ensure free sample function is available
      if (typeof check_free_sample_eligibility === "function") {
        check_free_sample_eligibility()
      }
      setTimeout(function(){
        animateCartContents('in');
      }, 100);
      if(callback) callback(); //run callback if argument was supplied
    }
  });

  //Update progress bar
  if($(".cart-progress-bar__text").length){
    $.ajax({
      type: 'GET',
      url: '/cart?view=mini-progress-bar',
      success: function(newPage){
        let newText = $(newPage).find(".cart-progress-bar__text");
        let newProgressBar = $(newPage).find('.cart-progress-bar__progress');
        $(".cart-progress-bar__text").replaceWith(newText); //update progress text
        let newWidth = newProgressBar.attr('data-width');
        $(".cart-progress-bar__progress").css('width',newWidth); //updates progress bar
      }
    });
  }

  // Update cart totals
  $.ajax({
    type: 'GET',
    url: '/cart?view=mini-totals-ajax',
    success: function(totals){
      $("#cart__totals").html(totals);
    }
  });

  // Inject free samples if not present in current DOM
  if(!$(".mini-cart__free-samples").length){
    $.ajax({
      type: 'GET',
      url: '/cart?view=mini-free-samples',
      success: function(samples){
        $(".mini-cart-items").after(samples);
      }
    });
  }
}

// Update minicart item totals
function updateCounts(items_in_cart){
  let items_display_count = items_in_cart || 0; // Use 0 if undefined
  $("[js-cart-item-count]").html(`(${items_display_count})`);
  let bubble_text = `
    <span aria-hidden="true">${items_display_count}</span>
    <span class="visually-hidden">${items_display_count + ' item'}${items_display_count == 1 ? '' : 's'}</span>
  `;
  $(".cart-count-bubble").html(bubble_text);
  let hide_when_empty = `
    .c-mini-cart__header .cart-qty,
    .header__icons .cart-count-bubble,
    #mini_checkout
  `
  if (items_display_count==0){
    $(hide_when_empty).hide();
  } else {
    $(hide_when_empty).show();
  }
}

// Show spinner and hide all cart contents
// @param - dir - value must be "in" or "out"
function animateCartContents(dir){
  if (dir=='in'){
    $(".hc-mini-table-wrapper").removeClass('loading');
    $(".hc-mini-table, .cart-qty, #cart__totals").animate({
      'opacity':1
    }, 500);
  } else {
    $(".hc-mini-table-wrapper").addClass('loading');
    $(".hc-mini-table, .cart-qty, #cart__totals").animate({
      'opacity':0
    }, 500);
  }
}

// Run cart refresh and buy box enable checks on page load
refresh_cart();
toggleBuyBoxPurchaseAllowed();

// Detect when user returns to page via back button and refresh cart
window.addEventListener('pageshow', function(event) {
  // event.persisted is true when page is loaded from browser cache (back/forward button)
  if (event.persisted) {
    refresh_cart();
    toggleBuyBoxPurchaseAllowed();
  }
});